import React from "react";
import { AppBar, Toolbar, Stack } from "@mui/material";
import { HamburgerMenu } from "@refinedev/mui";

import { LanguageMenu, UserInfo } from "./components";
import { useHeaderController } from "./controllar";
import { HeaderProps } from "./types";

export const Header: React.FC<HeaderProps> = ({ sticky = true }) => {
  const {
    user,
    mode,
    currentLocale,
    languageMenuAnchorEl,
    handleClickLanguageMenu,
    handleCloseMenu,
    handleToggleMode,
    changeLocale,
    i18n,
  } = useHeaderController();

  return (
    <AppBar position={sticky ? "sticky" : "relative"}>
      <Toolbar>
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          <HamburgerMenu />
            <Stack marginLeft={'auto'} direction="row" spacing={2}>
              {(user?.image || user?.full_name) && (
                  <UserInfo
                    user={user}
                    mode={mode}
                    currentLocale={currentLocale}
                    onToggleMode={handleToggleMode}
                    onClickLanguageMenu={handleClickLanguageMenu}
                  />
              )}
            </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
